import React from 'react';
import { PricePrice } from 'src/types';
import {
  priceLabelStylingType,
  priceLabel,
} from '@prisjakt/ui-price-label/src/types';
import * as S from './styles';
import { PriceDisplayEnum, PriceDisplay } from 'src/areas/product/types';

const getPriceLabelStyling = (
  isCampaign: boolean,
  storeIsFeatured?: boolean | null
): priceLabelStylingType => {
  if (!storeIsFeatured) return priceLabel.LIGHTEN;
  if (isCampaign) return priceLabel.CAMPAIGN;
  return priceLabel.PRIMARY;
};

const PriceLabel: React.FC<IPriceLabelProps> = ({
  price,
  priceDisplay,
  storeIsFeatured,
  isCampaign,
}) => {
  const mainPrice =
    priceDisplay === PriceDisplayEnum.PRICE_INCLUDES_SHIPPING &&
    price.inclShipping
      ? price.inclShipping
      : price.exclShipping;

  return (
    <>
      {mainPrice && (
        <S.PriceLabel
          value={mainPrice}
          styling={getPriceLabelStyling(isCampaign, storeIsFeatured)}
        />
      )}
    </>
  );
};

interface IPriceLabelProps {
  price: PricePrice;
  storeIsFeatured?: boolean | null;
  isCampaign: boolean;
  priceDisplay: PriceDisplay;
}

export default PriceLabel;
